//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import TopHeader from "./components/TopHeader";
import YearTotal from "@/components/YearTotal";
import SmallRegion from "./components/SmallRegion";
import NormalRegion from "./components/NormalRegion";
import LargeRegion from "./components/LargeRegion";
import mixin from "@/mixins/index";
import { getOperateData } from "@/api/operate";
import { formatOperateList } from "@/utils/operate";
import { formatRegionList } from "@/utils/region";
export default {
  components: { TopHeader, YearTotal, SmallRegion, NormalRegion, LargeRegion },
  name: "Operate",
  mixins: [mixin],
  data() {
    return {
      // 展示中型卡片
      isShowNormalCard: false,
      // 展示更多
      isShowMore: false,
      active: 1,
      regionName: "",
      regionList: [],
      tableData: [],
    };
  },
  created() {
    // 区域id
    this.regionName = this.$route.params.name;
    this.getData();
  },
  computed: {
    // 当前区域的信息
    currentRegionInfo() {
      let list = this.tableData[this.active];
      if (!list) return {};
      return list.find((v) => v.region === this.region.name) || {};
    },
    // 列表数据
    list() {
      if (this.tableData.length === 0) return [];
      let list = [...this.tableData[this.active]];
      if (this.isShowMore) {
        return list;
      } else {
        list.splice(4);
        return list;
      }
    },
  },
  methods: {
    onChange(index) {
      this.active = index;
    },
    onToShop(region) {
      const { name } = this.$route;
      if (name === "Operate") {
        this.$router.push(`/region/${region}`);
      } else if (name === "Region") {
        this.$router.push(`/shop/${region}`);
      }
    },
    onShowDetail(index) {
      let list = this.tableData[this.active];
      list = list.map((v, i) => ({
        ...v,
        isShowDetail: index === i ? !v.isShowDetail : false,
      }));
      this.$set(this.tableData, this.active, list);
    },
    // 超过4个以上，默认折叠
    onToggleClick() {
      this.isShowMore = !this.isShowMore;
    },
    onCityConfirm(region) {
      this.region = region;
      this.showPicker = false;
      if (this.$route.name === "Region") {
        this.getData(region.region, region.name);
      }
    },
    async getData(region, shop) {
      let data = {};
      region = region || this.regionName;
      if (this.$route.name === "Region") {
        data.search = JSON.stringify({ Region: region });
      }
      let rows = await getOperateData(data);
      if (region) {
        rows = formatRegionList(rows);
      } else {
        rows = formatOperateList(rows);
      }
      let { regionList, tableData } = rows;
      this.regionList = regionList;
      this.region = shop
        ? regionList.find((v) => v.name === shop)
        : regionList[0];
      this.tableData = tableData;
    },
  },
};
